import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import CloseIcon from "../../assets/images/employee/closeIcon.svg";
import {
  InputControl,
  TextareaControl,
} from "../../components/form/formControls";

/**
 * Popup xác nhận dùng chung cho trang Quản lý xăng xe
 * (đổi loại NV, duyệt / không duyệt đơn) — cùng kiểu form "Thêm xác nhận công và chức danh".
 * fields: [{ label, value }] hiển thị chỉ đọc; children: ô nhập thêm (vd chọn mức xăng xe) đặt trước ô ghi chú;
 * noteLabel: ô ghi chú (không bắt buộc).
 */
export default function FuelActionModal({
  isOpen,
  onClose,
  title,
  fields = [],
  message,
  noteLabel = "Ghi chú",
  notePlaceholder = "Nhập ghi chú (không bắt buộc)",
  submitText = "Xác nhận",
  onSubmit,
  children,
}) {
  const [note, setNote] = useState("");
  const [focused, setFocused] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) setNote("");
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await onSubmit(note.trim());
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        w={"100%"}
        maxW={"625px"}
      >
        <form onSubmit={handleSubmit}>
          <Flex flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                {title}
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIcon} />
              </Box>
            </Flex>

            <Flex p={"24px"} flexDirection={"column"}>
              <Box w={"100%"} maxW={"545px"} m={"8px auto 24px"}>
                {fields.map((f) => (
                  <Flex key={f.label} mb={"12px"}>
                    <InputControl
                      label={f.label}
                      value={f.value}
                      disabled
                      readonly
                      mwidth={"100%"}
                    />
                  </Flex>
                ))}

                {children}

                <Flex mb={"12px"}>
                  <TextareaControl
                    label={noteLabel}
                    placeholder={notePlaceholder}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    state={focused}
                    mwidth={"100%"}
                  />
                </Flex>

                {message ? (
                  <Text
                    fontSize={"12px"}
                    color={"var(--color-option-employee-hover)"}
                  >
                    {message}
                  </Text>
                ) : null}
              </Box>

              <Stack
                direction="row"
                spacing={4}
                align="center"
                justify={"flex-end"}
              >
                <Button
                  fontSize={"15px"}
                  fontWeight={"600"}
                  bg="var(--color-main)"
                  w={"112px"}
                  h={"44px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  color={"var(--color-option-employee-hover)"}
                  _hover={{ filter: "brightness(90%)" }}
                  onClick={onClose}
                >
                  Hủy
                </Button>
                <Button
                  type="submit"
                  isLoading={submitting}
                  fontSize={"15px"}
                  fontWeight={"600"}
                  color={"var(--color-main)"}
                  bg="var(--linear-gradient-employee)"
                  minW={"112px"}
                  h={"44px"}
                  _hover={{ filter: "brightness(90%)" }}
                >
                  {submitText}
                </Button>
              </Stack>
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
}
